var exports = {
  "Q": "xf85f6308--ebb45f--text",
};

module.exports = exports;
